import PropTypes from 'prop-types';
import { Icon } from '@eti/components';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import Media from 'react-media';

const wrapperStyles = (mediumAlignment) => css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
  max-width: 650px;
  text-align: center;

  @media ${mediaQueries.xlarge.only} {
    flex-direction: row;
  }

  @media ${mediaQueries.medium.up} and ${mediaQueries.large.down} {
    flex-direction: ${mediumAlignment};
  }
`;

const textStyles = (isSmallSize) => css`
  color: ${etiColors.black};
  font-size: 0.75rem;
  margin: 0 3px;

  @media ${mediaQueries.large.up} {
    font-size: ${isSmallSize ? '0.75rem' : '0.875rem'};
  }
`;

const trustFactStyles = css`
  @media ${mediaQueries.medium.up} {
    flex: 1 0 auto;
  }
`;

const iconStyles = css`
  vertical-align: middle;
`;

const TrustFactsPromo = ({ isSmallSize = false, mediumAlignment = 'row' }) => {
  const { t } = useTranslation();

  return (
    <Media query={mediaQueries.large.up}>
      {(matches) => (
        <div className={wrapperStyles(mediumAlignment)} data-testid="trustFactsPromo">
          <div className={trustFactStyles}>
            <Icon
              className={iconStyles}
              color={etiColors.grayScale[10]}
              id="plane-bold"
              size={matches && !isSmallSize ? '1rem' : '0.75rem'}
            />
            <span className={textStyles(isSmallSize)}>{t('Trust.AirlinesMessage.Text')}</span>
          </div>
          <div className={trustFactStyles}>
            <Icon
              className={iconStyles}
              color={etiColors.grayScale[10]}
              id="adult-traveler"
              size={matches && !isSmallSize ? '1rem' : '0.75rem'}
            />
            <span className={isSmallSize.toString()}>{t('Trust.CustomersMessage.Text')}</span>
          </div>
          <div className={trustFactStyles}>
            <Icon
              className={iconStyles}
              color={etiColors.grayScale[10]}
              id="lock"
              size={matches && !isSmallSize ? '1rem' : '0.75rem'}
            />
            <span className={isSmallSize.toString()}>{t('Trust.SecureMessage.Text')}</span>
          </div>
        </div>
      )}
    </Media>
  );
};

TrustFactsPromo.propTypes = {
  isSmallSize: PropTypes.bool,
  mediumAlignment: PropTypes.string,
};

export default TrustFactsPromo;
